export const company_data_en = {
	email: "info@nwdevelopment.co.uk",
	tel_local: "0203 290 2777",
	tel_international: "+44(0)203 290 2777",
	address_line_1: "20-22 Wenlock Road, N1 7GU",
	address_line_2: "London, United Kingdom",
};
